import { useMemo, useState } from "react";
import { Button, Card, Collapse } from "react-bootstrap";
import { FaChevronDown, FaFileAlt } from "react-icons/fa";
import { safeHtml } from "./detailProperty.helpers";

const DetailDescription = ({ property }) => {
  const [expanded, setExpanded] = useState(false);

  const html = useMemo(() => {
    const source = property?.description || property?.excerpt;
    return safeHtml(source);
  }, [property]);

  return (
    <Card className="detail-card">
      <Card.Body className="detail-card-body">
        <div className="detail-section-head">
          <h3 className="section-title mb-0">
            <FaFileAlt className="me-2" />
            Deskripsi Properti
          </h3>

          <Button
            variant="link"
            className="detail-description-toggle"
            onClick={() => setExpanded((prev) => !prev)}
            aria-expanded={expanded}
          >
            {expanded ? "Lihat Lebih Sedikit" : "Lihat Selengkapnya"}
            <FaChevronDown className={expanded ? "rotate-180" : ""} />
          </Button>
        </div>

        <div className={`detail-description-wrap ${expanded ? "expanded" : "collapsed"}`}>
          <div className="detail-description" dangerouslySetInnerHTML={{ __html: html }} />
        </div>

        <Collapse in={expanded}>
          <div className="detail-description-footer" />
        </Collapse>
      </Card.Body>
    </Card>
  );
};

export default DetailDescription;
